<div class="modal-overlay" (click)="onOverlayClick()">
  <div class="modal-box" (click)="$event.stopPropagation()" *ngIf="draft">
    <div class="modal-header">
      <div class="modal-header-info">
        <div class="modal-icon" [style.background]="draft.iconBg">
          <svg *ngIf="draft.icon === 'mask'" width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="draft.iconColor" stroke-width="2"><path d="M3 12c2-4 5-6 9-6s7 2 9 6c-2 4-5 6-9 6s-7-2-9-6z"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/></svg>
          <svg *ngIf="draft.icon === 'moderation'" width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="draft.iconColor" stroke-width="2"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
          <svg *ngIf="draft.icon === 'jailbreak'" width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="draft.iconColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          <svg *ngIf="draft.icon === 'topic'" width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="draft.iconColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <svg *ngIf="draft.icon === 'custom'" width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="draft.iconColor" stroke-width="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
        </div>
        <div class="modal-title-col">
          <div class="modal-title-row">
            <h2 class="modal-title">{{ draft.name }}</h2>
            <span class="type-badge">{{ draft.type }}</span>
          </div>
          <p class="modal-desc">{{ draft.description }}</p>
        </div>
      </div>
      <button class="close-btn" (click)="onCancel()">✕</button>
    </div>

    <div class="modal-enable-row">
      <span class="enable-label">Guardrail enabled</span>
      <div class="toggle-wrap">
        <button class="toggle" [class.on]="draft.enabled" (click)="toggleEnabled()">
          <span class="toggle-knob"></span>
        </button>
        <span class="toggle-text">{{ draft.enabled ? 'Enabled' : 'Disabled' }}</span>
      </div>
    </div>

    <div class="modal-body">
      <ng-container *ngIf="draft.kind === 'entities' || draft.kind === 'categories'">
        <div class="option-group" *ngFor="let group of draft.groups">
          <div class="group-header">
            <label class="check-row group-select-all">
              <input type="checkbox" [checked]="isGroupAllChecked(group.id)" (change)="toggleGroupAll(group.id)" />
              <span class="group-label">{{ group.label }}</span>
            </label>
            <span class="group-count">{{ selectedInGroup(group.id) }} of {{ group.options.length }}</span>
          </div>
          <div class="option-list">
            <label class="check-row option-row" *ngFor="let option of group.options">
              <input type="checkbox" [checked]="option.checked" (change)="toggleOption(group.id, option.id)" />
              <span class="option-text">
                <span class="option-label">{{ option.label }}</span>
                <span class="option-example" *ngIf="option.example">{{ option.example }}</span>
              </span>
            </label>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="draft.kind === 'threshold'">
        <p class="field-label">Detection sensitivity</p>
        <div class="threshold-row">
          <button
            *ngFor="let level of thresholds"
            class="threshold-pill"
            [class.active]="draft.threshold === level"
            (click)="setThreshold(level)"
          >{{ level }}</button>
        </div>
        <p class="field-hint">Higher sensitivity catches more jailbreak attempts but may flag more legitimate prompts.</p>
      </ng-container>

      <ng-container *ngIf="draft.kind === 'llm'">
        <p class="field-label">Model</p>
        <input class="text-field" name="model" type="text" [(ngModel)]="draft.model" />

        <p class="field-label">Confidence threshold</p>
        <input class="text-field" name="confidenceThreshold" type="number" min="0" max="1" step="0.1" [(ngModel)]="draft.confidenceThreshold" />

        <label class="check-row option-row">
          <input type="checkbox" name="includeReasoning" [(ngModel)]="draft.includeReasoning" />
          <span class="option-text">Include reasoning</span>
        </label>

        <ng-container *ngIf="draft.id === 'custom-prompt'">
          <p class="field-label">System prompt details</p>
          <textarea class="text-field" rows="5" name="systemPromptDetails" [(ngModel)]="draft.systemPromptDetails"></textarea>
        </ng-container>

        <p class="field-hint">These values map to the Guardrails JSON payload: model, confidence_threshold, include_reasoning, and system_prompt_details.</p>
      </ng-container>

      <ng-container *ngIf="draft.kind === 'url-list'">
        <p class="field-label">URL Allow List</p>
        <div class="url-input-row">
          <input class="text-field" type="text" placeholder="https://example.com" [(ngModel)]="newUrl" />
          <button class="add-url-btn" type="button" (click)="addUrl()">Add</button>
        </div>
        <div class="url-list">
          <div class="url-chip" *ngFor="let url of draft.urlAllowList ?? []">
            <span>{{ url }}</span>
            <button type="button" class="remove-url" (click)="removeUrl(url)">✕</button>
          </div>
        </div>
        <p class="field-hint">Allowed URLs will be sent as <code>url_allow_list</code> in the Guardrails JSON payload.</p>
      </ng-container>

      <ng-container *ngIf="draft.kind === 'text'">
        <p class="field-label">{{ draft.id === 'off-topic' ? 'Business scope' : 'Custom moderation prompt' }}</p>
        <textarea class="text-field" rows="5" [(ngModel)]="draft.text"></textarea>
      </ng-container>
    </div>

    <div class="modal-footer">
      <span class="footer-hint" *ngIf="draft.kind === 'entities' || draft.kind === 'categories'">
        {{ totalSelected() }} of {{ totalOptions() }} selected
      </span>
      <span class="footer-hint" *ngIf="draft.kind !== 'entities' && draft.kind !== 'categories'"></span>
      <div class="footer-actions">
        <app-button variant="secondary" size="sm" (clicked)="onCancel()">Cancel</app-button>
        <app-button variant="primary" size="sm" (clicked)="onSave()">Save Changes</app-button>
      </div>
    </div>
  </div>
</div>
